import {ChangeDetectorRef, Component, Inject, NgZone, OnInit, ViewChild, AfterContentChecked} from '@angular/core';
import {IwgSelectService} from '../../shared/services/iwgselect.service';
import {IwgSelect} from '../../shared/models/iwgselect.model';
import { UserService } from 'src/app/shared/services/user.service';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { AssignmentService } from 'src/app/shared/services/assignment.service';
import { DownloadService } from 'src/app/shared/services/download.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {IWGSharedService} from '../../shared/services/shared.service';
import {BehaviorSubject, forkJoin, Observable, of} from 'rxjs';
import { ManagerSelectComponent } from 'src/app/iwgcommon/formelements/manager-select/manager-select.component';
import { mergeMap, tap, map } from 'rxjs/operators';
import { WorkerSelectComponent } from 'src/app/iwgcommon/formelements/worker-select/worker-select.component';
import { Utils } from '../../shared/utils/utils';

@Component({
  selector: 'app-assignment-dialog',
  templateUrl: './assignment-dialog.component.html',
  styleUrls: ['./assignment-dialog.component.scss']
})
export class AssignmentDialogComponent implements OnInit {

  @ViewChild('assignmentStep1') assignmentStep1: NgForm;
  @ViewChild('assignmentStep2') assignmentStep2: NgForm;
  @ViewChild('assignmentStep3') assignmentStep3: NgForm;
  @ViewChild('assignmentStep4') assignmentStep4: NgForm;
  @ViewChild('managerList') managerList: ManagerSelectComponent;
  @ViewChild('workersList') workersList: WorkerSelectComponent;

  Ready = false;

  serviceId: any = null;
  quoteId: any = null;
  managerId: any = null;
  workerId: any = null;
  existingAssignment: any = null;
  isExistingTransferAssignment: any = null;
  isEditFromDetails: any = null;

  WizardTitle = 'Engage a Worker';
  AssignmentLabel = 'Engagement';
  AssignmentLabelLC = 'engagement';
  PayAmountTitle = 'Amount';
  SelectWorkerTitle = 'Select Worker';
  WorkerLabel = 'Worker';
  jobDescriptionRequired = true;
  IsCompliance = false;
  ShowComplianceRegions = false;
  payStructureHelpText = 'Choose how the Contractor will be paid.';

  numberOfSteps = 3;
  US_EOR = false;
  allowEndClients = null;
  allowTeams = null;
  isFileUploadInProgress = false;

  existingAssignmentId = null;
  isLoading = false;
  maxSteps = 5;
  selectedStepIndex = 0;
  pageLoaded = false;
  masterDataLoaded = false;
  isTransferToAOR: boolean = false;
  TransferEvaluationID = null;
  step1 = {
      is_entity_in_country: false,
      service_type_id: 1,
      selectedManager: null,
      title: '',
      is_expat: null,
      expat_nationality: null,
      is_expat_visa_required: null,
      is_worker_in_country: null,
      selectedTeam: null,
      selectedQuote: null,
      selectedEndClient: null,
      selectedQuoteSimple: null,
      selectedStateCompliance: null,
      selectedCountry: null,
      selectedWorker: null
  };
  step2 = {
      sowFileID: null,
      offerLetterFileID: null,
      is_offer_letter_sent: false,
      is_offer_letter_needed: false,
      is_sow_allowed: false,
      is_track_delivery_date: false,
      is_track_spend_allowed: false,
      maximum_spend: null,
      job_description_file_quote_id: null,
      external_identifier_label: '',
      sowFileName: '',
      offerLetterFileName: '',
      job_title: '',
      job_description: '',
      job_description_file: null,
      job_description_file_id: null,
      jobDescriptionFileName: null,
      jobDescriptionFileID: null,
      jobDescriptionFile: null,
      start_date: null,
      hours_per_week: null,
      estimated_end_date: null,
      time_for_notice: '',
      department: '',
      cost_center: '',
      po: '',
      offer_letter_file: null,
      offer_letter_file_id: null,
      sow_file: null,
      sow_file_id: null,
      external_identifier: null
  };
  step3 = {
      is_overtime_authorized: false,
      is_expenses_authorized: false,
      is_commission_authorized: false,
      is_bonus_authorized: false,
      fulltime: true,
      regular: true,
      exempt: false,
      hours_per_week: null,
      pay_rate: null,
      other_compensation: null,
      selectedPayRateType: {ID: '', Name: ''},
      selectedPayRateType1: null,
      selectedCurrency: null,
      selectedPayRateTypeStructure: null
  };
  
  step4 = {
      is_travel_required: false,
      travel_locations : '',
      is_driving_required: false,
      is_equipment_provided: false,
      equipment_provided: '',
      is_working_from_home: false,
      worksite_street1: '',
      worksite_street2: '',
      worksite_city: '',
      worksite_postal_code: '',
      selectedCountry: null,
      selectedState: null
  };

  quotesSimple: IwgSelect[] = [];

  JobTitleLabel = '';
  JobTitleLabelLC = '';
  preselectedQuoteId: any = null;
  Filter_ClientID = null;
  selectedWorkerID = null;
  selectedManagerID = null;

  expat_nationality_id = null;
  Hposition: MatSnackBarHorizontalPosition = 'right';
  VPosition: MatSnackBarVerticalPosition = 'top';
  flag = false;
  eorPayRateHelpTxt: string;
  isFileRequired: boolean;
  clicked: boolean;
    isEmbed = false;
  constructor(
    private router: Router,
    private download: DownloadService,
    private quote: IwgSelectService,
    private user: UserService,
    public utils: Utils,
    private assignmentService: AssignmentService,
    private downloadService: DownloadService,
    private dialogRef: MatDialogRef<AssignmentDialogComponent>,
    private toast: MatSnackBar,
    private sharedService: IWGSharedService,
    private ngZone: NgZone,
    private cdref: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) private data: {
      serviceId: any,
      quoteId: any,
      managerId: any,
      workerId: any,
      existingAssignment: any,
      isExistingTransferAssignment: any,
      isEditFromDetails: any,
      isTransferToAOR: any,
      fetchInProgress: boolean
    }
  ) {
    if (!data.fetchInProgress) {
      this.existingAssignment = this.data.existingAssignment;
      this.initData();
    }
  }
  initData(): void {
    this.allowEndClients = this.user.getAllowEndClients();
    this.allowTeams = this.user.getAllowTeams();
    this.serviceId = this.data.serviceId;
    this.quoteId = this.data.quoteId;
    this.managerId = this.data.managerId;
    this.workerId = this.data.workerId;
    this.isExistingTransferAssignment = this.data.isExistingTransferAssignment;
    this.isEditFromDetails = this.data.isEditFromDetails;
    this.isTransferToAOR = this.data.isTransferToAOR;

    if (this.serviceId == 3) {
      this.AssignmentLabel = 'Evaluation';
      this.AssignmentLabelLC = 'evaluation';
      this.JobTitleLabel = 'Service Type';
      this.JobTitleLabelLC = 'service type';
      this.WizardTitle = 'Evaluate a Contractor';
      this.PayAmountTitle = 'Total Project Amount';
      this.SelectWorkerTitle = 'Select Contractor';
      this.WorkerLabel = 'Contractor';
      this.IsCompliance = true;
    }

    if (this.existingAssignment) {
      if(this.isTransferToAOR == true){
        this.preselectedQuoteId = this.quoteId;
      } else{
        if (this.existingAssignment.QuoteID) {
          this.preselectedQuoteId = this.existingAssignment.QuoteID;
        } else {
            console.error('Assignment ' + this.existingAssignment.ID + ' does not have a quote associated with it.');
        }
      }
      this.populateForm(this.existingAssignment, this.isTransferToAOR);
    } else if (this.quoteId) {
        this.preselectedQuoteId = this.quoteId;
    }
   
    if (this.managerId) {
        this.selectedManagerID = this.managerId;
    }
    if (this.workerId) {
        this.selectedWorkerID = this.workerId;
    }
    if (this.data.fetchInProgress) {
      this.loadMasters();
    } else {
      this.masterDataLoaded = true;
    }
      this.loadQuotes();
      this.isEmbed = this.sharedService.getIsEmbed();
  }
  ngAfterViewInit(){
    setTimeout(()=>{  
      this.pageLoaded = true;
      this.cdref.detectChanges();
    },100); 
  }
  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnInit(): void {
     
        this.flag = false;
        this.sharedService.iwgfileuploaded.subscribe((data) => {
            if (data == null) {return; }
            if(this.pageLoaded)
            {
              this.jobDescriptionRequired = false;
            }
        });
        this.sharedService.iwgfileuploadstatus.subscribe((data) => {
          if (data == null) {return; }
          this.isFileUploadInProgress = data;
      });
  }

  loadMasters(): void {
    this.isLoading = true;
    const req1 = this.quote.getManagers();
    const req2 = this.quote.getWorkers();
    forkJoin([req1, req2]).subscribe((response) => {
      this.isLoading = false;
      if (response && response.length) {
        if (this.managerList) {
          this.managerList.items = response[0].data.Data;
        }
        if (this.workersList) {
          this.workersList.items = response[1].data.Data;
        }
      }
      this.masterDataLoaded = true;
    });
  }

  getManagers(): Observable<void> {
    return this.quote.getManagers().pipe(map((res) => {
      if (this.managerList) {
        this.managerList.items = res.data.Data;
      }
    }));
  }

  getWorkers(): Observable<void> {
    return this.quote.getWorkers().pipe(map((res) => {
      if (this.workersList) {
        this.workersList.items = res.data.Data;
      }
    }));
  }

  loadQuotes(){
    this.quote.getQuotes({
      format_hint: 'price_list_drop_down',
      service_type_id: this.serviceId
    }).subscribe(
      data => {
        const quotes = data.data.Data;
        this.quotesSimple = data.data.Data;
        if (this.preselectedQuoteId){
          const q = quotes.find(quote => quote.ID == this.preselectedQuoteId);
          if (!q) {
              console.error('Could not find quote ID ' + this.preselectedQuoteId + ' in the list of quotes');
          }else{
            this.step1.selectedQuoteSimple = q;
            this.onselectedQuoteChange({value: q});
            this.prepopulateQuoteFields(q);
          }
        }
      },
      err => {
        console.log('Error :: ', err);
      }
    );
  }
  populateForm(existingAssignment: any, isTransferToAOR: any){
    if (existingAssignment) {

        if(isTransferToAOR == true && existingAssignment.IsTransferToAOR == false){
          this.existingAssignmentId = null;
          this.TransferEvaluationID = existingAssignment.DisplayID;
        } else{
          this.existingAssignmentId = existingAssignment.ID;
          this.isTransferToAOR = existingAssignment.IsTransferToAOR;
          this.TransferEvaluationID = existingAssignment.TransferEvaluationID;
        }

        this.step1.selectedQuote = existingAssignment.Quote;
        Object.assign(this.step1, {
            title: this.utils.htmlDecode(existingAssignment.Title),
            quote_id: existingAssignment.QuoteID,
            service_type_id: parseInt(existingAssignment.Service.ServiceTypeEnumID),
            manager_id: existingAssignment.Manager.ID,
            team_id: (existingAssignment.Team != null) ? existingAssignment.Team.ID : 0,
            worker_id: existingAssignment.Worker.ID,
            is_entity_in_country: existingAssignment.EntityInCountry,
            country_id: existingAssignment.Country.ID
        });
        this.selectedManagerID = existingAssignment.Manager.ID;
        this.selectedWorkerID = existingAssignment.Worker.ID;
        if (this.step1.service_type_id == 1) {
            this.step1.is_expat = existingAssignment.IsExpat;
            this.step1.is_expat_visa_required = existingAssignment.IsExpatVisaNeeded;
            this.step1.is_worker_in_country = existingAssignment.IsExpatInCountry;
            this.expat_nationality_id = existingAssignment.ExpatCountryID;
            if (existingAssignment.ExpatCountryID != null) {
                this.step1.expat_nationality = {
                    ID: existingAssignment.ExpatCountryID,
                    Name: existingAssignment.ExpatCountryName
                };
            }
        }
        this.step1.selectedCountry = existingAssignment.Country;
        this.step1.selectedWorker = existingAssignment.Worker;
        this.step1.selectedManager = existingAssignment.Manager;
        this.step1.selectedTeam = existingAssignment.Team;
        if (existingAssignment.EndClient.ID != '00000000-0000-0000-0000-000000000000') {
            this.step1.selectedEndClient = existingAssignment.EndClient;
        } else {
            this.step1.selectedEndClient = 0;
        }
        if (this.step1.selectedCountry.HasRegions) {
            this.ShowComplianceRegions = true;
        }

        this.step1.selectedStateCompliance = existingAssignment.Region;
        if(isTransferToAOR == true){
          Object.assign(this.step2, {
            job_title: this.utils.htmlDecode(existingAssignment.JobTitle),
            job_description: existingAssignment.JobDescription,
            job_description_file: existingAssignment.JobDescriptionFile.Name,
            job_description_file_id: existingAssignment.JobDescriptionFile.ID,
            start_date: new Date(existingAssignment.StartDate),
            estimated_end_date: existingAssignment.ExpectedEndDate ? new Date(existingAssignment.ExpectedEndDate) : null,
            department: existingAssignment.Department,
            cost_center: existingAssignment.CostCenter,
            po: existingAssignment.PO,
            time_for_notice: existingAssignment.TimeForNotice
          });
        } else{
          Object.assign(this.step2, {
            is_offer_letter_sent: existingAssignment.IsOfferLetterAttached,
            is_offer_letter_needed: existingAssignment.IsOfferLetterNeeded,
            job_title: this.utils.htmlDecode(existingAssignment.JobTitle),
            job_description: existingAssignment.JobDescription,
            maximum_spend: existingAssignment.maximum_spend,

            job_description_file: existingAssignment.JobDescriptionFile.Name,
            job_description_file_id: existingAssignment.JobDescriptionFile.ID,
            offer_letter_file: existingAssignment.OfferLetterFile.Name,
            offer_letter_file_id: existingAssignment.OfferLetterFile.ID,
            sow_file: existingAssignment.SOWFile.Name,
            sow_file_id: existingAssignment.SOWFile.ID,

            start_date: new Date(existingAssignment.StartDate),
            estimated_end_date: existingAssignment.ExpectedEndDate ? new Date(existingAssignment.ExpectedEndDate) : null,
            department: existingAssignment.Department,
            cost_center: existingAssignment.CostCenter,
            external_identifier: existingAssignment.ExternalIdentifier,
            po: existingAssignment.PO,
            time_for_notice: existingAssignment.TimeForNotice
          });
        }

        if (existingAssignment.JobDescriptionFile) {
            if (this.step1.service_type_id != 3 && existingAssignment.JobDescriptionFile.Name || existingAssignment.JobDescriptionFile.ID != '00000000-0000-0000-0000-000000000000') {
                this.jobDescriptionRequired = false; 
                
            }
            if (this.step1.service_type_id == 3 && existingAssignment.JobDescriptionFile.ID != '00000000-0000-0000-0000-000000000000') {
                this.jobDescriptionRequired = false;
            }
            this.step2.jobDescriptionFileName = existingAssignment.JobDescriptionFile.Name;
            this.step2.jobDescriptionFileID = existingAssignment.JobDescriptionFile.ID;
        }

        if (existingAssignment.OfferLetterFile) {
            this.step2.offerLetterFileName = existingAssignment.OfferLetterFile.Name;
            this.step2.offerLetterFileID = existingAssignment.OfferLetterFile.ID;
        }

        if (existingAssignment.SOWFile) {
            this.step2.sowFileName = existingAssignment.SOWFile.Name;
            this.step2.sowFileID = existingAssignment.SOWFile.ID;
        }

        Object.assign(this.step3, {
            pay_rate: existingAssignment.PayRate,
            is_overtime_authorized: existingAssignment.IsOvertimeAuthorized,
            is_expenses_authorized: existingAssignment.IsExpensesAuthorized,
            is_commission_authorized: existingAssignment.IsCommissionAuthorized,
            is_bonus_authorized: existingAssignment.IsBonusAuthorized,
            other_compensation: existingAssignment.OtherCompensation,
            hours_per_week: existingAssignment.hours_per_week,
            fulltime: (existingAssignment.IsPT == true) ? false : true,
            regular: (existingAssignment.IsSporadic == true) ? false : true,
            exempt: existingAssignment.IsExempt,
        });

        this.step3.selectedCurrency = existingAssignment.PayCurrency;
        this.step3.selectedPayRateType = existingAssignment.PayRateTimeframe;

        if (existingAssignment.PayRateTimeframeStructure?.Name == null && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3)) {
            this.step3.selectedPayRateTypeStructure = isTransferToAOR ? existingAssignment.PayRateTimeframeStructure : 0;
        } else {
            this.step3.selectedPayRateTypeStructure = existingAssignment.PayRateTimeframeStructure;
        }

        Object.assign(this.step4, {
            is_travel_required: existingAssignment.IsTravelRequired,
            travel_locations: existingAssignment.TravelLocations,
            is_driving_required: existingAssignment.IsDrivingRequired,
            is_equipment_provided: existingAssignment.IsEquipmentProvided,
            equipment_provided: existingAssignment.EquipmentProvided,
            is_working_from_home: existingAssignment.IsWorkingFromHome,
            worksite_street1: existingAssignment.WorksiteAddress.StreetAddress1,
            worksite_street2: existingAssignment.WorksiteAddress.StreetAddress2,
            worksite_city: existingAssignment.WorksiteAddress.City,
            worksite_postal_code: existingAssignment.WorksiteAddress.PostalCode,
            worksite_country_id: existingAssignment.WorksiteAddress.Country.ID,
            worksite_state_id: existingAssignment.WorksiteAddress.Region.ID
        });

        this.step4.selectedCountry = existingAssignment.WorksiteAddress.Country;
        this.step4.selectedState = existingAssignment.WorksiteAddress.Region;

        this.SetAssignmentLabel();
        this.Ready = true;
    }
  }
  setContext(quote)
  {  
      this.step1.service_type_id = parseInt(quote.QuoteRequest_Service_ServiceTypeEnumID);
      if (quote && quote.QuoteRequest_Service_Name != null)
      {
          this.US_EOR = false;
          if (quote.QuoteRequest_Country_Abbreviation == 'US' && quote.QuoteRequest_Service_Name.trim() == 'Employer of Record')
          {
              this.US_EOR = true;
          }
      }
      if (quote && quote.QuoteRequest_Service_Name != null) {
          if (quote.QuoteRequest_Service_Name.trim() == 'Compliance') {
              this.IsCompliance = true;
          }
      }
  }
  SetAssignmentLabel()
  {
      this.numberOfSteps = 4;
      this.JobTitleLabel = 'Job Title';
      this.JobTitleLabelLC = 'job title';
      this.AssignmentLabel = 'Assignment';
      this.AssignmentLabelLC = 'assignment';
      this.SelectWorkerTitle = 'Select Worker';
      this.WorkerLabel = 'Worker';
      this.PayAmountTitle = 'Amount';

      if (this.step1.service_type_id == 2) {
          this.WizardTitle = 'Engage a Contractor';
          this.SelectWorkerTitle = 'Select Contractor';
          this.WorkerLabel = 'Contractor';
          this.AssignmentLabel = 'Engagement';
          this.AssignmentLabelLC = 'engagement';
          this.JobTitleLabel = 'Service Type';
          this.JobTitleLabelLC = 'service type';
          this.PayAmountTitle = 'Total Project Amount';
          this.numberOfSteps = 3;
          this.sharedService.workertitlecontractor.next(true);
        
      }
      if (this.step1.service_type_id == 3 || this.serviceId == 3) {
          this.AssignmentLabel = 'Evaluation';
          this.AssignmentLabelLC = 'evaluation';
          this.JobTitleLabel = 'Service Type';
          this.JobTitleLabelLC = 'service type';
          this.WizardTitle = 'Evaluate a Contractor';
          this.SelectWorkerTitle = 'Select Contractor';
          this.WorkerLabel = 'Contractor';
          this.PayAmountTitle = 'Total Project Amount';
          this.IsCompliance = true;
          this.numberOfSteps = 3;
          this.sharedService.workertitlecontractor.next(true);
         
          this.step3.selectedPayRateType1 = 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075';
      }
  }
  prepopulateQuoteFields(quote) {
      if (quote && quote.QuoteRequest_Service_ServiceTypeEnumID != null) {
        
        this.setContext(quote);
        this.step1.is_entity_in_country = quote.QuoteRequest_DoesCompanyHaveBusinessEntityInCountry;
        this.step1.service_type_id = parseInt(quote.QuoteRequest_Service_ServiceTypeEnumID);
        
        if(this.isTransferToAOR != true){
          this.ShowComplianceRegions = false;
          if (quote.QuoteRequest_Country_HasRegions > 0) {
            this.ShowComplianceRegions = true;
          }
          this.step1.selectedStateCompliance = {
              ID: quote.QuoteRequest_Region_ID,
              Name: quote.QuoteRequest_Region_Name
          };
          if (this.step1.service_type_id == 1) {
              this.step1.expat_nationality = null;
              this.step1.is_expat = quote.QuoteRequest_IsWorkerLocal == 0 ? true : false; 
              this.step1.is_expat_visa_required = quote.QuoteRequest_IsVisaRequired == 1 ? true : false;
              this.step1.is_worker_in_country = quote.QuoteRequest_IsWorkerInCountry == 1 ? true : false;
              this.expat_nationality_id = quote.QuoteRequest_ExpatCountry_ID;
              if (quote.QuoteRequest_ExpatCountry_ID != null) {
                  this.step1.expat_nationality = {
                      ID: quote.QuoteRequest_ExpatCountry_ID,
                      Name: quote.QuoteRequest_ExpatCountry_Name
                  };
              } else {
                  this.step1.expat_nationality = {
                      ID: null,
                      Name: null
                  };
              }
          }
          else {
              this.step1.is_expat = false;
          }

        if (!this.US_EOR){
            this.step2.job_title = this.utils.htmlDecode(quote.QuoteRequest_JobTitle);
            this.step2.job_description = quote.QuoteRequest_JobDescription;
            this.step1.title = this.utils.htmlDecode(quote.QuoteRequest_Title);
            this.step1.selectedTeam = {
                ID: quote.QuoteRequest_Team_ID,
                Name: quote.QuoteRequest_Team_Name
            };

           
            this.step2.job_description_file = quote.QuoteRequest_JobDescriptionFile_Name;
            this.step2.job_description_file_id = quote.QuoteRequest_JobDescriptionFile_ID;
            this.step2.job_description_file_quote_id = quote.QuoteRequest_JobDescriptionFile_ID;
            this.step2.jobDescriptionFileName = quote.QuoteRequest_JobDescriptionFile_Name;
            this.step2.jobDescriptionFileID = quote.QuoteRequest_JobDescriptionFile_ID;
            this.step2.jobDescriptionFile = {
                Name: quote.QuoteRequest_JobDescriptionFile_Name,
                ID: quote.QuoteRequest_JobDescriptionFile_ID
            };

            if (quote.QuoteRequest_JobDescriptionFile_ID && this.step1.service_type_id == 3 && quote.QuoteRequest_JobDescriptionFile_ID != '00000000-0000-0000-0000-000000000000') {
                this.jobDescriptionRequired = false; 
            }
            const d = new Date(quote.QuoteRequest_StartDate);
            const hours = d.getHours();
            d.setHours(0);
            this.step2.start_date = d;

            this.step3.hours_per_week = quote.QuoteRequest_TypicalWeeklyHours;
            this.step3.pay_rate = quote.QuoteRequest_PayRate;
            this.step3.is_commission_authorized = quote.QuoteRequest_IsCommissionAuthorized;
            this.step3.is_bonus_authorized = quote.QuoteRequest_IsBonusAuthorized;
            this.step3.other_compensation = quote.QuoteRequest_OtherCompensation;

            this.step4.is_travel_required = quote.QuoteRequest_EngagementIncludesTravel;
            if(quote.QuoteRequest_EngagementIncludesTravel==0){
              this.step4.is_travel_required = false;
            }
            if(quote.QuoteRequest_EngagementIncludesTravel==1){
              this.step4.is_travel_required = true;
            }
         

            this.step4.selectedCountry = {
                ID: quote.QuoteRequest_Country_ID,
                Abbreviation: quote.QuoteRequest_Country_Abbreviation,
                HasRegions: quote.QuoteRequest_Country_HasRegions,
                Name: quote.QuoteRequest_Country_Name
            };
            this.step4.selectedState = {
                ID: quote.QuoteRequest_Region_ID,
                Name: quote.QuoteRequest_Region_Name
            };
            this.step3.selectedPayRateType = {
              ID: quote.QuoteRequest_PayPeriodicity_ID,
              Name: quote.QuoteRequest_PayPeriodicity_Name
          };            
          }  
              

          this.step4.selectedCountry = {
              ID: quote.QuoteRequest_Country_ID,
              Abbreviation: quote.QuoteRequest_Country_Abbreviation,
              HasRegions: quote.QuoteRequest_Country_HasRegions,
              Name: quote.QuoteRequest_Country_Name
          };
          this.step3.selectedCurrency = {
              ID: quote.QuoteRequest_PayCurrency_ID,
              Symbol: quote.QuoteRequest_PayCurrency_Symbol,
              Abbreviation: quote.QuoteRequest_PayCurrency_Abbreviation
          };
          this.step1.selectedEndClient = {
              ID: quote.QuoteRequest_EndClient_ID,
              Name: quote.QuoteRequest_EndClient_Name,
              ClientID: quote.QuoteRequest_EndClient_ClientID

          };

        
          if (this.step1.service_type_id == 3) {
              this.step3.pay_rate = 0;
              this.step3.selectedPayRateType1 = 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075';
              this.step3.selectedPayRateTypeStructure = 0;
              this.step2.job_title = '';
          }
          if (this.step1.service_type_id == 2) {
              this.step3.selectedPayRateType1 = 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075';
              this.step3.selectedPayRateTypeStructure = 0;
              this.step3.pay_rate = 0;
          }         
        }
        
        this.SetAssignmentLabel();
        this.Ready = true;

    } else {
        console.error('No quote request');
    }
  }

  onselectedQuoteChange(selected){
    const d = selected.value;
    this.quote.getSingleQuote(d.ID).subscribe(
      data => {
        if (data.apiCallStatus != 1 || !data.data.Data){
          return;
        }        
        this.step1.selectedQuote = data.data.Data;
        if (parseInt(data.data.Data.QuoteRequest_Service_ServiceTypeEnumID) == 1) { 
            this.sharedService.workerselecttoupdateeor.next(true);
         
        } else {
            this.sharedService.workerselecttoupdateaorcompliance.next(true);
           
        }

       
        console.warn(this.existingAssignment);
        if (!this.existingAssignmentId) {

            this.prepopulateQuoteFields(data.data.Data);
        }
        else
        {
            this.setContext(data.data.Data); 
        }
      },
      err => {
        console.log('Error :: ', err);
      }
    );
  }

  nextStep(): void {
    let canProceed = false;
    const stepIndex = this.selectedStepIndex + 1;
    switch (stepIndex) {
      case 1:
          canProceed = this.assignmentStep1.valid;
          if(this.step1.selectedStateCompliance<=0 || (this.step1 && this.step1.selectedStateCompliance && this.step1.selectedStateCompliance.ID==null )){
            this.step1.selectedStateCompliance=null;
          }
          if (this.step1.service_type_id == 3 && this.step1.selectedStateCompliance == null && this.step4.selectedCountry.HasRegions == true) {
              alert('Please select a state or region');
              canProceed = false;
          }
          break;
      case 2:
          canProceed = this.assignmentStep2.valid;
          break;
      case 3:
          canProceed = this.assignmentStep3.valid;
          break;
      case 4:
          canProceed = this.assignmentStep4.valid;
         
          if (this.step4.selectedState == null && this.step4.selectedCountry.HasRegions == true)
          {
              alert('Please select a state or region for the worksite');
              canProceed = false;
          }
          break;
      case -1:
          canProceed = true;
          break;
    }
    if (canProceed) {
      this.saveDraft().then(data => {
          let index = (this.selectedStepIndex == this.maxSteps) ? 0 : this.selectedStepIndex + 1;
          if (index == 3 && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3)) { index = 4; }
        
          this.selectedStepIndex = index;
          this.sharedService.isStateChange.next(true);
          this.clicked = false;
      });
    }
    this.resetFileErrorMessages();

  }
  resetFileErrorMessages() {
   
    this.sharedService.iwgfileattachedreset.next(false);
    
  }

  prevStep(): void {
    this.resetFileErrorMessages();
    this.selectedStepIndex -= 1;
    if (this.selectedStepIndex == 3 && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3)) { this.selectedStepIndex = 2; }
  }
  saveDraft() {
   
      const statusId = 1;
      return this.save(statusId);
  }
  save(statusId) {
    this.isLoading = true;
    const props = {
      request_from_client_portal: true,
      new_status_id: statusId
    };
    if (this.assignmentStep1.valid){
      let CountryID = 0;
      let EntityInCountry = false;
      if (this.step1.selectedCountry != null)
      {
          CountryID = this.step1.selectedCountry.ID;
      }
      if (this.step1.is_entity_in_country != null)
      {
          EntityInCountry = this.step1.is_entity_in_country;
      }     
      const obj1 = {
        title: this.utils.htmlDecode(this.step1.title),
        end_client_id: (this.step1.selectedEndClient != null) ? this.step1.selectedEndClient.ID : 0,
        quote_id: this.step1.selectedQuoteSimple.ID,
        service_type_id: parseInt(this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID),
        manager_id: this.step1.selectedManager.ID,
      
        team_id: (this.step1.selectedTeam != null) ? this.step1.selectedTeam.ID : 0,
        is_entity_in_country: EntityInCountry, 
        worker_id: this.step1.selectedWorker.ID,
      
        country_id: CountryID, 
        job_description_file_quote_id: this.step2.job_description_file_quote_id,
        is_expat: this.step1.is_expat,
        is_expat_visa_required: this.step1.is_expat_visa_required,
        is_worker_in_country: this.step1.is_worker_in_country,
        expat_nationality_id: (this.step1.expat_nationality != null) ? this.step1.expat_nationality.ID : null,
        worksite_country_id: this.step4.selectedCountry?.ID
        
      };
      Object.assign(props, obj1);
      if(this.isTransferToAOR == true){
        const objT = {
          worksite_country_id: this.step4.selectedCountry?.ID,                   
          is_transfer_to_AOR: true,
          transfer_evaluation_ID: this.TransferEvaluationID,
          start_date: this.step2.start_date,
          estimated_end_date: this.step2.estimated_end_date,
          department: this.step2.department,
          cost_center: this.step2.cost_center,
          po: this.step2.po,
          job_title: this.utils.htmlDecode(this.step2.job_title),
          job_description: this.step2.job_description,
          job_description_file: this.step2.job_description_file,
          job_description_file_id: this.step2.job_description_file_id,
          pay_rate: this.step3.pay_rate,
          pay_rate_type_id: this.step3.selectedPayRateType ? this.step3.selectedPayRateType.ID : null,
          pay_rate_type_structure_id: this.step3.selectedPayRateTypeStructure ? this.step3.selectedPayRateTypeStructure.ID : null
        }
        Object.assign(props, objT);
      }

      if ((this.step1.service_type_id == 3 || this.step1.service_type_id == 2) && this.step1.selectedStateCompliance) {
          Object.assign(props, {worksite_state_id: this.step1.selectedStateCompliance.ID});
      }
    }
    if (this.assignmentStep2.valid){
      Object.assign(props, {
        is_offer_letter_sent: this.step2.is_offer_letter_sent,
        is_offer_letter_needed: this.step2.is_offer_letter_needed,
        job_title: this.utils.htmlDecode(this.step2.job_title),
        job_description: this.step2.job_description,
        maximum_spend: this.step2.maximum_spend,

        job_description_file: this.step2.job_description_file,
        job_description_file_id: this.step2.job_description_file_id,
        offer_letter_file: this.step2.offer_letter_file,
        offer_letter_file_id: this.step2.offer_letter_file_id,
        sow_file: this.step2.sow_file,
        sow_file_id: this.step2.sow_file_id,

        start_date: this.step2.start_date,
        estimated_end_date: this.step2.estimated_end_date,
        department: this.step2.department,
        cost_center: this.step2.cost_center,
        po: this.step2.po,
        external_identifier: this.step2.external_identifier,
        time_for_notice: this.step2.time_for_notice
      });
    }
    if (this.step1.service_type_id == 1 || this.step1.service_type_id == 2 || this.step1.service_type_id == 3)
    {
      if (this.assignmentStep3.valid) {
        Object.assign(props, {
          pay_rate: this.step3.pay_rate,
          pay_rate_type_id: (this.step1.service_type_id == 3) ? 'A54EFAF9-CCAE-4321-9D1D-A9F98B9CF075' :  this.step3.selectedPayRateType?.ID,
          pay_rate_type_structure_id: (this.step3.selectedPayRateTypeStructure == null) ? 0 :  this.step3.selectedPayRateTypeStructure?.ID,
          currency_id: this.step3.selectedCurrency.ID,
          is_overtime_authorized: this.step3.is_overtime_authorized,
          is_expenses_authorized: this.step3.is_expenses_authorized,
          is_commission_authorized: this.step3.is_commission_authorized,
          is_bonus_authorized: this.step3.is_bonus_authorized,
          other_compensation: this.step3.other_compensation,
          weekly_hours: this.step3.hours_per_week,
          is_part_time: !this.step3.fulltime,          
          is_sporadic: !this.step3.regular,
          exempt_status: this.step3.exempt ? 'Exempt' : 'Non-Exempt',  
      });
      }
    }
    if (this.step1.service_type_id == 1)
    {
      
        if (this.assignmentStep4.valid) {
            Object.assign(props, {
                is_travel_required: this.step4.is_travel_required,
                travel_locations: this.step4.travel_locations,
                is_driving_required: this.step4.is_driving_required,
                is_equipment_provided: this.step4.is_equipment_provided,
                equipment_provided: this.step4.equipment_provided,

                is_working_from_home: this.step4.is_working_from_home,

                worksite_street1: this.step4.worksite_street1,
                worksite_street2: this.step4.worksite_street2,
                worksite_city: this.step4.worksite_city,
                worksite_postal_code: this.step4.worksite_postal_code,
                worksite_country_id: this.step4.selectedCountry?.ID,
            });

            if (this.step4.selectedState) {
                Object.assign(props, {
                    worksite_state_id: this.step4.selectedState.ID,
                });
            }
        }
    }
    if (this.existingAssignmentId) {
      return this.assignmentService.update(this.existingAssignmentId, props)
      .toPromise()
      .then(data => {this.onSaveSuccess(data); return data; })
      .catch(err => this.onSaveError(err));
    } else {
      return  this.assignmentService.save(props)
      .toPromise()
      .then(data => {this.onSaveSuccess(data); return data; })
      .catch(err => this.onSaveError(err));
    }

  }
  onSaveSuccess(response){

    this.isLoading = false;
    const data = response.data;
    if (response.apiCallStatus == 1){
      this.existingAssignmentId = data.Data ? data.Data.ID : null;
      if (data.ErrorCode != 200) {
          
      }
    
      this.sharedService.isStateChange.next(true);
      this.updateFormFields();
      this.sharedService.AssignmentChange.next(true);
     
    }
  }
  onSaveError(error){
    this.isLoading = false;
    console.error(error);
  }

  updateFormFields() {
    this.assignmentService.getAssignmentById(this.existingAssignmentId)
    .subscribe(
      updatedAssignment => {
          if (updatedAssignment.data.ErrorCode != 200){
            return;
          }
          updatedAssignment = updatedAssignment.data.Data;
          if (updatedAssignment.JobDescriptionFile) {
            this.step2.job_description_file = updatedAssignment.JobDescriptionFile.Name;
            this.step2.job_description_file_id = updatedAssignment.JobDescriptionFile.ID;
        }
          if (updatedAssignment.OfferLetterFile) {
            this.step2.offer_letter_file = updatedAssignment.OfferLetterFile.Name;
            this.step2.offer_letter_file_id = updatedAssignment.OfferLetterFile.ID;
        }

          if (updatedAssignment.SOWFile) {
            this.step2.sow_file = updatedAssignment.SOWFile.Name;
            this.step2.sow_file_id = updatedAssignment.SOWFile.ID;
        }

          this.step2.is_sow_allowed = updatedAssignment.AllowSOWUpload;
          this.step2.is_track_delivery_date = updatedAssignment.TrackDeliveryDate;
          this.step2.is_track_spend_allowed = false; 
          this.step2.external_identifier_label = updatedAssignment.ExternalIdentifierLabel;
      }
    );
  }
  submit(){
    const statusId = 2;
    this.save(statusId).then((response: any) => {
      if (response.apiCallStatus != 1){
          return;
      }
      if (response.data.ErrorCode == 200) {
          this.dialogRef.close();
          if (this.step1.service_type_id == 2)
          {
              this.showConfirmationToast('Thank you! The engagement is pending onboarding.');
          }
          else if (this.step1.service_type_id == 3) {
              this.showConfirmationToast('Thank you! The evaluation will be started.');
          }
          else
          {
              this.showConfirmationToast('Thank you! We will respond to your request within 1 business day.');
          }         
          let redirectToServicePage = 1;
          if (this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID != null) {
              redirectToServicePage = this.step1.selectedQuote.QuoteRequest_Service_ServiceTypeEnumID;
          }

          if (this.sharedService.getIsEmbed() == true) {
            setTimeout(()=>{    this.sharedService.sendPostMessageToParentWindow({ source: 2, service: redirectToServicePage });
          },2000); //this.router.navigate(['erwsdczxassignments'], { queryParams: { service: redirectToServicePage } });

          } else {
              this.router.navigate(['assignments'], { queryParams: { service: redirectToServicePage } });
          }

      } else {
          this.showConfirmationToast('Error submitting form.');
         
      }
    });
  }
  saveAsDraft(){
    this.saveDraft().then((response: any) => {
     
        if (response.data.ErrorCode == 200) {
          this.sharedService.isStateChange.next(true);
          this.dialogRef.close();          
          this.showConfirmationToast('Draft has been saved.');
          if (this.isEditFromDetails == true) {
            this.dialogRef.close();
          }
      } else {
          this.showConfirmationToast('Error saving draft.');
      }
    })
    .catch(err => {console.log(err); });
  }

  canProceed(){

    const step = this.selectedStepIndex + 1;
    let valid = false;
    if (this['assignmentStep' + step]) {
        valid = this['assignmentStep' + step].valid;
    }
    if(this.step1.service_type_id == 1) {
      this.eorPayRateHelpTxt = 'Assignment pay information specified in the associated quote.';
    } else {
      this.eorPayRateHelpTxt = 'Choose how the contractor will be paid';
    }

    if(this.step1.service_type_id == 3) {
      this.isFileRequired = true
    } else {
      this.isFileRequired = false
    }

    if(this.step1.selectedStateCompliance<=0 ||(this.step1 && this.step1.selectedStateCompliance && this.step1.selectedStateCompliance.ID==null )){
      this.step1.selectedStateCompliance=null;
    }
    if (step == 1 && (this.step1.service_type_id == 2 || this.step1.service_type_id == 3) && this.step1.selectedStateCompliance == null && this.step4.selectedCountry.HasRegions == true) {
      valid = false;
    }
    if (step == 2 && this.jobDescriptionRequired == true && this.step1.service_type_id == 3) {
      valid = false;
    }
    if (step == 3 && this.step3.pay_rate <= 0){
        valid = false;
    }
    if(step == 3 && this.step3.selectedPayRateType && (this.step3.selectedPayRateType.ID==null || this.step3.selectedPayRateType.ID==""))
    {
      valid = false;
    }
    if(this.step3.selectedPayRateTypeStructure<=0 || (this.step3 && this.step3.selectedPayRateTypeStructure && this.step3.selectedPayRateTypeStructure.ID==null )){
      this.step3.selectedPayRateTypeStructure=null;
    }

    if (this.step1.service_type_id!=1 && step == 3 && !this.step3.selectedPayRateTypeStructure){
      valid = false;  
    }
           
    if (this.step1.service_type_id == 3 && step >= 4) {
      valid = true;
    }


  if(step ==4 && this.step4.selectedCountry?.HasRegions && (this.step4.selectedState == null || this.step4.selectedState.ID ==null))
   {
    valid = false;  
   }
   
  
    return valid;
  }
  showConfirmationToast(text){
    this.toast.open(text, 'Got it', {
      duration: 2000, horizontalPosition: this.Hposition,
      verticalPosition: this.VPosition,
      panelClass: 'iwg-toast-text-white',
    });
  }
  cancel(){
    if (this.isEditFromDetails == true) {
    }
    this.dialogRef.close();
  }
  downloadJobDescriptionFile(){
    this.downloadService.saveAs('/Api/File/' + this.step2.job_description_file_id);
  }
  downloadSOWFile(){
    this.downloadService.saveAs('/Api/File/' + this.step2.sow_file_id);
  }
  downloadOfferLetterFile(){
    this.downloadService.saveAs('/Api/File/' + this.step2.offer_letter_file_id);
  }
}
